let isMiniprogramEnter = null // null 表示尚未判断
let envPromise = null

function isEmbeddedIframe() {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

function finishEnv(value) {
  isMiniprogramEnter = !!value
  sessionStorage.setItem('isMiniprogramEnter', isMiniprogramEnter)
  return isMiniprogramEnter
}

// 返回 Promise 的封装
export function checkMiniProgramEnv() {
  if (envPromise) return envPromise

  envPromise = new Promise((resolve) => {
    const ua = navigator.userAgent.toLowerCase()
    if (!ua.includes('micromessenger')) {
      sessionStorage.setItem('isWeChat', false)
      resolve(finishEnv(false))
      return
    }

    sessionStorage.setItem('isWeChat', true)

    // uni-app H5 的 web-view 是 iframe：微信不往 iframe 注入 WeixinJSBridge，
    // getEnv 经常永不回调。这不是小程序原生 web-view。
    if (isEmbeddedIframe()) {
      resolve(finishEnv(false))
      return
    }

    let settled = false
    const done = (value) => {
      if (settled) return
      settled = true
      resolve(finishEnv(value))
    }

    try {
      if (typeof wx !== 'undefined' && wx.miniProgram && typeof wx.miniProgram.getEnv === 'function') {
        wx.miniProgram.getEnv((res) => {
          done(!!(res && res.miniprogram))
        })
        setTimeout(() => done(false), 500)
      } else {
        done(false)
      }
    } catch (e) {
      done(false)
    }
  })

  return envPromise
}

// 获取同步值（确保初始化后调用）
export function getMiniProgramEnv() {
  return isMiniprogramEnter
}
